interface SlideOneProps {
  storeName: string;
  donationString: string;
}

export const SlideOne = ({ storeName, donationString }: SlideOneProps) => {
  return (
    <div class='slide slide-one'>
      <div class='header'>
        <strong>Create Impact</strong>
        <div><i>w/</i> {storeName}</div>
      </div>
      <div class='center-content'>
        <div>
          <strong>Shop &amp; Unlock</strong>
        </div>
        <div>life-changing impact,</div>
        <div>together</div>
        <img src={`https://${import.meta.env.VITE_MEDIA_HOST}/black-heart.svg`} alt="Heart" />
      </div>
      <div class="footer">
        <div>Unlock a free {donationString} donation after checkout!</div>
        <div>
          <span class="powered-by">POWERED BY</span>
          <img src={`https://${import.meta.env.VITE_MEDIA_HOST}/inspired-logo.svg`} alt='Logo' />
        </div>
      </div>
    </div>
  );
};
